import { useEffect } from "react";
import AppHeader from "./Header";
import PageContent from "./PageContent";
// import AppFooter from "./Footer";

const HomePage = () => {
  useEffect(() => {
    // Create the Tawk script dynamically
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://embed.tawk.to/68cc02313b6def191d3bc1af/1j5eeh4mt";
    script.charset = "UTF-8";
    script.setAttribute("crossorigin", "*");
    document.body.appendChild(script);

    // Cleanup: remove the script when the component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div>
      <AppHeader />
      <PageContent />
      {/* <AppFooter /> */}
    </div>
  );
};

export default HomePage;
